export default "/img/BY.1ab7c43d566cf42dcb6a4c7a74f4684d.png";